

import React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Container } from 'react-bootstrap';
import DataReactTable from './components/DataReactTable';

const RejectTable = () => (
  <div>
    
    <Container>
      <Breadcrumbs 
        aria-label="breadcrumb"
        style={{
          marginLeft: '12px',
          marginBottom: '5px',
        }}
      >
      
        <Typography sx={{ color: 'text.primary' }}>Agent</Typography>
        <Typography sx={{ color: 'text.primary' }}>Payment</Typography>
        <Typography sx={{ color: 'text.primary' }}>Rejected</Typography>
    
      </Breadcrumbs>
      {/* <Row>
      <Col md={12} />
    </Row>
    <Row> */}
      <DataReactTable />
      {/* </Row> */}
    </Container>
  </div>
 
  );

export default RejectTable;

